import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListQuantityCell } from './emsp-bo-rfid-badge-order-list-quantity.cell';
import { EmspBoRfidBadgeOrderListQuantityHeader } from './emsp-bo-rfid-badge-order-list-quantity.header';

export const EmspBoRfidBadgeOrderListQuantityColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['quantity']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListQuantityHeader,
  cell: EmspBoRfidBadgeOrderListQuantityCell,
};
